import axios from 'axios';

const API_URL = 'https://mokalive.net:8000/api';

/**
 * クォータ情報取得サービス
 */
export interface QuotaStatus {
  limit: number;
  used: number;
  remaining: number;
  usage_percent: number;
  warning: boolean;
  critical: boolean;
  last_updated: string;
}

export interface DailyUsage {
  date: string;
  total_calls: number;
  total_input_tokens: number;
  total_output_tokens: number;
  success_count: number;
  error_count: number;
  success_rate: number;
}

export const quotaService = {
  /**
   * 現在のクォータ状態を取得
   */
  async getQuotaStatus(): Promise<QuotaStatus> {
    try {
      console.log('クォータ状態取得中:', `${API_URL}/quota/status/`);
      const response = await axios.get(`${API_URL}/quota/status/`);
      console.log('クォータ状態レスポンス:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('クォータ状態取得失敗:', error.response || error.message);
      throw error;
    }
  },

  /**
   * 日次使用統計を取得
   */
  async getDailyUsage(date?: string): Promise<DailyUsage> {
    try {
      const url = date 
        ? `${API_URL}/quota/daily/?date=${date}`
        : `${API_URL}/quota/daily/`;
      console.log('日次使用統計取得中:', url);
      const response = await axios.get(url);
      console.log('日次使用統計レスポンス:', response.data);
      return response.data;
    } catch (error: any) {
      console.error('日次使用統計取得失敗:', error.response || error.message);
      throw error;
    }
  },

  /**
   * 使用状況の詳細情報を取得
   */
  async getUsageDetails(): Promise<any> {
    try {
      const response = await axios.get(`${API_URL}/quota/details/`);
      return response.data;
    } catch (error) {
      console.error('Failed to fetch usage details:', error);
      throw error;
    }
  }
};
